import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RightPanelComponent } from './right-panel/right-panel.component';
import { FooterPanelComponent } from './footer-panel/footer-panel.component';
import { HeaderComponent } from './header/header.component';
import { LeftPanelComponent } from './left-panel/left-panel.component';
import { AutoFocusComponent } from './custom-directives/auto-focus.component';
import {FormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ErrorComponent } from './error/error.component';
import { MainComponent } from './main/main.component';



@NgModule({
  declarations: [
    AppComponent,
    RightPanelComponent,
    FooterPanelComponent,
    HeaderComponent,
    LeftPanelComponent,
    AutoFocusComponent,
    ErrorComponent,
    MainComponent,
  
    
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
